<app-vitamin-d-supplement
  htmlTitle="<strong>Support Skin Health</strong> with Vitamin D"
  question="Would you like to include Vitamin D as part of your treatment plan?"
>
  <p class="mb-4">
    Vitamin D plays a role in maintaining <strong>healthy skin and supporting immune function</strong>. For some
    individuals with skin conditions, adequate Vitamin D levels may help support overall skin health alongside
    prescribed treatment.
  </p>
  <p class="mb-4">
    While it is not a replacement for your medication, adding <strong>Vitamin D</strong> may complement your treatment
    plan.
  </p>
</app-vitamin-d-supplement>
